'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openUpdatePasswordModal = exports.openSetPasswordModal = exports.openSendSellerMessageModal = exports.openRetractBidModal = exports.openRegisterForCatalogModal = exports.openAbstenteeBidModal = exports.openLoginModal = exports.openLiveBidModal = exports.openItemDescriptionModal = exports.openInstallFlashModal = exports.openHealthcheckModal = exports.openForgotPasswordModal = exports.openDownloadMobileModal = exports.openCreateAccountModal = exports.openConsignmentConfirmModal = exports.openConfirmPasswordModal = exports.openCompleteAccountModal = exports.openAddSearchAlertModal = exports.dismissUpdatePasswordModal = exports.dismissSetPasswordModal = exports.dismissSendSellerMessageModal = exports.dismissRetractBidModal = exports.dismissRegisterForCatalogModal = exports.dismissLoginModal = exports.dismissLiveBidModal = exports.dismissItemDescriptionModal = exports.dismissInstallFlashModal = exports.dismissHealthcheckModal = exports.dismissForgotPasswordModal = exports.dismissDownloadMobileModal = exports.dismissCreateAccountModal = exports.dismissConsignmentConfirmModal = exports.dismissConfirmPasswordModal = exports.dismissCompleteAccountModal = exports.dismissAddSearchAlertModal = exports.dismissAbsenteeBidModal = exports.completeSendSellerMessageModal = exports.completeLoginModal = exports.getOpenModal = exports.OPEN_SET_PASSWORD_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_RETRACT_BID_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_LOGIN_MODAL = exports.OPEN_LIVE_BID_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = exports.OPEN_HEALTHCHECK_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = exports.DISMISS_SET_PASSWORD_MODAL = exports.DISMISS_SEND_SELLER_MESSAGE_MODAL = exports.DISMISS_RETRACT_BID_MODAL = exports.DISMISS_REGISTER_FOR_CATALOG_MODAL = exports.DISMISS_LOGIN_MODAL = exports.DISMISS_LIVE_BID_MODAL = exports.DISMISS_ITEM_DESCRIPTION_MODAL = exports.DISMISS_INSTALL_FLASH_MODAL = exports.DISMISS_HEALTHCHECK_MODAL = exports.DISMISS_FORGOT_PASSWORD_MODAL = exports.DISMISS_DOWNLOAD_MOBILE_MODAL = exports.DISMISS_CREATE_ACCOUNT_MODAL = exports.DISMISS_CONSIGNMENT_CONFIRM_MODAL = exports.DISMISS_CONFIRM_PASSWORD_MODAL = exports.DISMISS_COMPLETE_ACCOUNT_MODAL = exports.DISMISS_CHANGE_PASSWORD_MODAL = exports.DISMISS_ADD_SEARCH_ALERT_MODAL = exports.DISMISS_ABSENTEE_BID_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_LOGIN_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _shouldLogin = require('../modules/shouldLogin');

var _completeAccount = require('../modules/completeAccount');

var _createAccount = require('../modules/createAccount');

var _reselect = require('reselect');

var _forgotPassword = require('../modules/forgotPassword');

var _login = require('../modules/login');

var _enums = require('../../enums');

var _registerForCatalog = require('../modules/registerForCatalog');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var COMPLETE_COMPLETE_ACCOUNT_MODAL = exports.COMPLETE_COMPLETE_ACCOUNT_MODAL = 'COMPLETE_COMPLETE_ACCOUNT_MODAL';
var COMPLETE_CONFIRM_PASSWORD_MODAL = exports.COMPLETE_CONFIRM_PASSWORD_MODAL = 'COMPLETE_CONFIRM_PASSWORD_MODAL';
var COMPLETE_LOGIN_MODAL = exports.COMPLETE_LOGIN_MODAL = 'COMPLETE_LOGIN_MODAL'; // this is not used.  LOGIN_SUCCESS is used instead.
var COMPLETE_SEND_SELLER_MESSAGE_MODAL = exports.COMPLETE_SEND_SELLER_MESSAGE_MODAL = 'COMPLETE_SEND_SELLER_MESSAGE_MODAL';
var DISMISS_ABSENTEE_BID_MODAL = exports.DISMISS_ABSENTEE_BID_MODAL = 'DISMISS_ABSENTEE_BID_MODAL';
var DISMISS_ADD_SEARCH_ALERT_MODAL = exports.DISMISS_ADD_SEARCH_ALERT_MODAL = 'DISMISS_ADD_SEARCH_ALERT_MODAL';
var DISMISS_CHANGE_PASSWORD_MODAL = exports.DISMISS_CHANGE_PASSWORD_MODAL = 'DISMISS_CHANGE_PASSWORD_MODAL';
var DISMISS_COMPLETE_ACCOUNT_MODAL = exports.DISMISS_COMPLETE_ACCOUNT_MODAL = 'DISMISS_COMPLETE_ACCOUNT_MODAL';
var DISMISS_CONFIRM_PASSWORD_MODAL = exports.DISMISS_CONFIRM_PASSWORD_MODAL = 'DISMISS_CONFIRM_PASSWORD_MODAL';
var DISMISS_CONSIGNMENT_CONFIRM_MODAL = exports.DISMISS_CONSIGNMENT_CONFIRM_MODAL = 'DISMISS_CONSIGNMENT_CONFIRM_MODAL';
var DISMISS_CREATE_ACCOUNT_MODAL = exports.DISMISS_CREATE_ACCOUNT_MODAL = 'DISMISS_CREATE_ACCOUNT_MODAL';
var DISMISS_DOWNLOAD_MOBILE_MODAL = exports.DISMISS_DOWNLOAD_MOBILE_MODAL = 'DISMISS_DOWNLOAD_MOBILE_MODAL';
var DISMISS_FORGOT_PASSWORD_MODAL = exports.DISMISS_FORGOT_PASSWORD_MODAL = 'DISMISS_FORGOT_PASSWORD_MODAL';
var DISMISS_HEALTHCHECK_MODAL = exports.DISMISS_HEALTHCHECK_MODAL = 'DISMISS_HEALTHCHECK_MODAL';
var DISMISS_INSTALL_FLASH_MODAL = exports.DISMISS_INSTALL_FLASH_MODAL = 'DISMISS_INSTALL_FLASH_MODAL';
var DISMISS_ITEM_DESCRIPTION_MODAL = exports.DISMISS_ITEM_DESCRIPTION_MODAL = 'DISMISS_ITEM_DESCRIPTION_MODAL';
var DISMISS_LIVE_BID_MODAL = exports.DISMISS_LIVE_BID_MODAL = 'DISMISS_LIVE_BID_MODAL';
var DISMISS_LOGIN_MODAL = exports.DISMISS_LOGIN_MODAL = 'DISMISS_LOGIN_MODAL';
var DISMISS_REGISTER_FOR_CATALOG_MODAL = exports.DISMISS_REGISTER_FOR_CATALOG_MODAL = 'DISMISS_REGISTER_FOR_CATALOG_MODAL';
var DISMISS_RETRACT_BID_MODAL = exports.DISMISS_RETRACT_BID_MODAL = 'DISMISS_RETRACT_BID_MODAL';
var DISMISS_SEND_SELLER_MESSAGE_MODAL = exports.DISMISS_SEND_SELLER_MESSAGE_MODAL = 'DISMISS_SEND_SELLER_MESSAGE_MODAL';
var DISMISS_SET_PASSWORD_MODAL = exports.DISMISS_SET_PASSWORD_MODAL = 'DISMISS_SET_PASSWORD_MODAL';
var OPEN_ABSENTEE_BID_MODAL = exports.OPEN_ABSENTEE_BID_MODAL = 'OPEN_ABSENTEE_BID_MODAL';
var OPEN_ADD_SEARCH_ALERT_MODAL = exports.OPEN_ADD_SEARCH_ALERT_MODAL = 'OPEN_ADD_SEARCH_ALERT_MODAL';
var OPEN_CHANGE_PASSWORD_MODAL = exports.OPEN_CHANGE_PASSWORD_MODAL = 'OPEN_CHANGE_PASSWORD_MODAL';
var OPEN_COMPLETE_ACCOUNT_MODAL = exports.OPEN_COMPLETE_ACCOUNT_MODAL = 'OPEN_COMPLETE_ACCOUNT_MODAL';
var OPEN_CONFIRM_PASSWORD_MODAL = exports.OPEN_CONFIRM_PASSWORD_MODAL = 'OPEN_CONFIRM_PASSWORD_MODAL';
var OPEN_CONSIGNMENT_CONFIRM_MODAL = exports.OPEN_CONSIGNMENT_CONFIRM_MODAL = 'OPEN_CONSIGNMENT_CONFIRM_MODAL';
var OPEN_CREATE_ACCOUNT_MODAL = exports.OPEN_CREATE_ACCOUNT_MODAL = 'OPEN_CREATE_ACCOUNT_MODAL';
var OPEN_DOWNLOAD_MOBILE_MODAL = exports.OPEN_DOWNLOAD_MOBILE_MODAL = 'OPEN_DOWNLOAD_MOBILE_MODAL';
var OPEN_FORGOT_PASSWORD_MODAL = exports.OPEN_FORGOT_PASSWORD_MODAL = 'OPEN_FORGOT_PASSWORD_MODAL';
var OPEN_HEALTHCHECK_MODAL = exports.OPEN_HEALTHCHECK_MODAL = 'OPEN_HEALTHCHECK_MODAL';
var OPEN_INSTALL_FLASH_MODAL = exports.OPEN_INSTALL_FLASH_MODAL = 'OPEN_INSTALL_FLASH_MODAL';
var OPEN_ITEM_DESCRIPTION_MODAL = exports.OPEN_ITEM_DESCRIPTION_MODAL = 'OPEN_ITEM_DESCRIPTION_MODAL';
var OPEN_LIVE_BID_MODAL = exports.OPEN_LIVE_BID_MODAL = 'OPEN_LIVE_BID_MODAL';
var OPEN_LOGIN_MODAL = exports.OPEN_LOGIN_MODAL = 'OPEN_LOGIN_MODAL';
var OPEN_REGISTER_FOR_CATALOG_MODAL = exports.OPEN_REGISTER_FOR_CATALOG_MODAL = 'OPEN_REGISTER_FOR_CATALOG_MODAL';
var OPEN_RETRACT_BID_MODAL = exports.OPEN_RETRACT_BID_MODAL = 'OPEN_RETRACT_BID_MODAL';
var OPEN_SEND_SELLER_MESSAGE_MODAL = exports.OPEN_SEND_SELLER_MESSAGE_MODAL = 'OPEN_SEND_SELLER_MESSAGE_MODAL';
var OPEN_SET_PASSWORD_MODAL = exports.OPEN_SET_PASSWORD_MODAL = 'OPEN_SET_PASSWORD_MODAL';

// reducer
var DEFAULT_STATE = {
    modal: _enums.modalTypes.NONE
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _completeAccount.COMPLETE_ACCOUNT_SUCCESS:
        case COMPLETE_COMPLETE_ACCOUNT_MODAL:
        case COMPLETE_SEND_SELLER_MESSAGE_MODAL:
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
        case DISMISS_ABSENTEE_BID_MODAL:
        case DISMISS_ADD_SEARCH_ALERT_MODAL:
        case DISMISS_CHANGE_PASSWORD_MODAL:
        case DISMISS_COMPLETE_ACCOUNT_MODAL:
        case DISMISS_CONFIRM_PASSWORD_MODAL:
        case DISMISS_CONSIGNMENT_CONFIRM_MODAL:
        case DISMISS_CREATE_ACCOUNT_MODAL:
        case DISMISS_DOWNLOAD_MOBILE_MODAL:
        case DISMISS_FORGOT_PASSWORD_MODAL:
        case DISMISS_HEALTHCHECK_MODAL:
        case DISMISS_INSTALL_FLASH_MODAL:
        case DISMISS_ITEM_DESCRIPTION_MODAL:
        case DISMISS_LOGIN_MODAL:
        case DISMISS_REGISTER_FOR_CATALOG_MODAL:
        case DISMISS_RETRACT_BID_MODAL:
        case DISMISS_SEND_SELLER_MESSAGE_MODAL:
        case DISMISS_SET_PASSWORD_MODAL:
        case _login.LOGIN_SUCCESS:
        case _registerForCatalog.REGISTER_FOR_CATALOG_SUCCESS:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.NONE
            });
        case OPEN_ADD_SEARCH_ALERT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ADD_SEARCH_ALERT
            });
        case OPEN_ABSENTEE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ABSENTEE_BID
            });
        case OPEN_COMPLETE_ACCOUNT_MODAL:
        case _shouldLogin.OPEN_COMPLETE_ACCOUNT_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.COMPLETE_ACCOUNT
            });
        case OPEN_CREATE_ACCOUNT_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SIGN_UP
            });
        case OPEN_DOWNLOAD_MOBILE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.DOWNLOAD_MOBILE
            });
        case OPEN_HEALTHCHECK_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.HEALTHCHECK
            });
        case OPEN_INSTALL_FLASH_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.INSTALL_FLASH
            });
        case OPEN_ITEM_DESCRIPTION_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.ITEM_DESCRIPTION
            });
        case OPEN_CHANGE_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CHANGE_PASSWORD
            });
        case OPEN_CONFIRM_PASSWORD_MODAL:
        case _shouldLogin.OPEN_CONFIRM_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_PASSWORD
            });
        case OPEN_CONSIGNMENT_CONFIRM_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.CONFIRM_CONSIGNMENT
            });
        case _forgotPassword.FORGOT_PASSWORD_FAIL:
        case OPEN_FORGOT_PASSWORD_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.FORGOT_PASSWORD
            });
        case OPEN_LIVE_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LIVE_BID
            });
        case OPEN_LOGIN_MODAL:
        case _shouldLogin.OPEN_LOGIN_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.LOGIN
            });
        case OPEN_RETRACT_BID_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.RETRACT_BID
            });
        case OPEN_REGISTER_FOR_CATALOG_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.REGISTER_FOR_AUCTION
            });
        case OPEN_SEND_SELLER_MESSAGE_MODAL:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SEND_SELLER_MESSAGE
            });
        case OPEN_SET_PASSWORD_MODAL:
        case _shouldLogin.OPEN_SET_PASSWORD_MODAL_FROM_CHECKER:
            return (0, _extends3.default)({}, state, {
                modal: _enums.modalTypes.SET_PASSWORD
            });
        default:
            return state;
    }
}

/* SELECTORS */
var modalSelector = function modalSelector(state) {
    return state.ui.modal;
};

var getOpenModal = exports.getOpenModal = (0, _reselect.createSelector)(modalSelector, function (modal) {
    return modal.modal || _enums.modalTypes.NONE;
});

/* ACTION CREATORS */
var completeLoginModal = exports.completeLoginModal = function completeLoginModal() {
    return {
        type: COMPLETE_LOGIN_MODAL
    };
};

var completeSendSellerMessageModal = exports.completeSendSellerMessageModal = function completeSendSellerMessageModal() {
    return {
        type: COMPLETE_SEND_SELLER_MESSAGE_MODAL
    };
};

var dismissAbsenteeBidModal = exports.dismissAbsenteeBidModal = function dismissAbsenteeBidModal() {
    return {
        type: DISMISS_ABSENTEE_BID_MODAL
    };
};

var dismissAddSearchAlertModal = exports.dismissAddSearchAlertModal = function dismissAddSearchAlertModal() {
    return {
        type: DISMISS_ADD_SEARCH_ALERT_MODAL
    };
};

var dismissCompleteAccountModal = exports.dismissCompleteAccountModal = function dismissCompleteAccountModal() {
    return {
        type: DISMISS_COMPLETE_ACCOUNT_MODAL
    };
};

var dismissConfirmPasswordModal = exports.dismissConfirmPasswordModal = function dismissConfirmPasswordModal() {
    return {
        type: DISMISS_CONFIRM_PASSWORD_MODAL
    };
};

var dismissConsignmentConfirmModal = exports.dismissConsignmentConfirmModal = function dismissConsignmentConfirmModal() {
    return {
        type: DISMISS_CONSIGNMENT_CONFIRM_MODAL
    };
};

var dismissCreateAccountModal = exports.dismissCreateAccountModal = function dismissCreateAccountModal() {
    return {
        type: DISMISS_CREATE_ACCOUNT_MODAL
    };
};

var dismissDownloadMobileModal = exports.dismissDownloadMobileModal = function dismissDownloadMobileModal() {
    return {
        type: DISMISS_DOWNLOAD_MOBILE_MODAL
    };
};

var dismissForgotPasswordModal = exports.dismissForgotPasswordModal = function dismissForgotPasswordModal() {
    return {
        type: DISMISS_FORGOT_PASSWORD_MODAL
    };
};

var dismissHealthcheckModal = exports.dismissHealthcheckModal = function dismissHealthcheckModal() {
    return {
        type: DISMISS_HEALTHCHECK_MODAL
    };
};

var dismissInstallFlashModal = exports.dismissInstallFlashModal = function dismissInstallFlashModal() {
    return {
        type: DISMISS_INSTALL_FLASH_MODAL
    };
};

var dismissItemDescriptionModal = exports.dismissItemDescriptionModal = function dismissItemDescriptionModal() {
    return {
        type: DISMISS_ITEM_DESCRIPTION_MODAL
    };
};

var dismissLiveBidModal = exports.dismissLiveBidModal = function dismissLiveBidModal() {
    return {
        type: DISMISS_LIVE_BID_MODAL
    };
};

var dismissLoginModal = exports.dismissLoginModal = function dismissLoginModal() {
    return {
        type: DISMISS_LOGIN_MODAL
    };
};

var dismissRegisterForCatalogModal = exports.dismissRegisterForCatalogModal = function dismissRegisterForCatalogModal() {
    return {
        type: DISMISS_REGISTER_FOR_CATALOG_MODAL
    };
};

var dismissRetractBidModal = exports.dismissRetractBidModal = function dismissRetractBidModal() {
    return {
        type: DISMISS_RETRACT_BID_MODAL
    };
};

var dismissSendSellerMessageModal = exports.dismissSendSellerMessageModal = function dismissSendSellerMessageModal() {
    return {
        type: DISMISS_SEND_SELLER_MESSAGE_MODAL
    };
};

var dismissSetPasswordModal = exports.dismissSetPasswordModal = function dismissSetPasswordModal() {
    return {
        type: DISMISS_SET_PASSWORD_MODAL
    };
};

var dismissUpdatePasswordModal = exports.dismissUpdatePasswordModal = function dismissUpdatePasswordModal() {
    return {
        type: DISMISS_CHANGE_PASSWORD_MODAL
    };
};

var openAddSearchAlertModal = exports.openAddSearchAlertModal = function openAddSearchAlertModal() {
    return {
        type: OPEN_ADD_SEARCH_ALERT_MODAL
    };
};

var openCompleteAccountModal = exports.openCompleteAccountModal = function openCompleteAccountModal() {
    return {
        type: OPEN_COMPLETE_ACCOUNT_MODAL
    };
};

var openConfirmPasswordModal = exports.openConfirmPasswordModal = function openConfirmPasswordModal(payload) {
    return {
        payload: payload,
        type: OPEN_CONFIRM_PASSWORD_MODAL
    };
};

var openConsignmentConfirmModal = exports.openConsignmentConfirmModal = function openConsignmentConfirmModal() {
    return {
        type: OPEN_CONSIGNMENT_CONFIRM_MODAL
    };
};

var openCreateAccountModal = exports.openCreateAccountModal = function openCreateAccountModal() {
    return {
        type: OPEN_CREATE_ACCOUNT_MODAL
    };
};

var openDownloadMobileModal = exports.openDownloadMobileModal = function openDownloadMobileModal() {
    return {
        type: OPEN_DOWNLOAD_MOBILE_MODAL
    };
};

var openForgotPasswordModal = exports.openForgotPasswordModal = function openForgotPasswordModal() {
    return {
        type: OPEN_FORGOT_PASSWORD_MODAL
    };
};

var openHealthcheckModal = exports.openHealthcheckModal = function openHealthcheckModal() {
    return {
        type: OPEN_HEALTHCHECK_MODAL
    };
};

var openInstallFlashModal = exports.openInstallFlashModal = function openInstallFlashModal() {
    return {
        type: OPEN_INSTALL_FLASH_MODAL
    };
};

var openItemDescriptionModal = exports.openItemDescriptionModal = function openItemDescriptionModal(itemId) {
    return {
        payload: itemId,
        type: OPEN_ITEM_DESCRIPTION_MODAL
    };
};

var openLiveBidModal = exports.openLiveBidModal = function openLiveBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_LIVE_BID_MODAL
    };
};

var openLoginModal = exports.openLoginModal = function openLoginModal() {
    return {
        type: OPEN_LOGIN_MODAL
    };
};

var openAbstenteeBidModal = exports.openAbstenteeBidModal = function openAbstenteeBidModal(itemId, bidAmount) {
    return {
        payload: { bidAmount: bidAmount, itemId: itemId },
        type: OPEN_ABSENTEE_BID_MODAL
    };
};

var openRegisterForCatalogModal = exports.openRegisterForCatalogModal = function openRegisterForCatalogModal(_ref) {
    var catalogId = _ref.catalogId,
        _ref$fromBiddingConso = _ref.fromBiddingConsole,
        fromBiddingConsole = _ref$fromBiddingConso === undefined ? false : _ref$fromBiddingConso;
    return {
        payload: { catalogId: catalogId, fromBiddingConsole: fromBiddingConsole },
        type: OPEN_REGISTER_FOR_CATALOG_MODAL
    };
};

var openRetractBidModal = exports.openRetractBidModal = function openRetractBidModal(itemId) {
    return {
        payload: { itemId: itemId },
        type: OPEN_RETRACT_BID_MODAL
    };
};

var openSendSellerMessageModal = exports.openSendSellerMessageModal = function openSendSellerMessageModal(messageDetails, sellerId, sellerName, subject, title) {
    return {
        payload: { messageDetails: messageDetails, sellerId: sellerId, sellerName: sellerName, subject: subject, title: title },
        type: OPEN_SEND_SELLER_MESSAGE_MODAL
    };
};

var openSetPasswordModal = exports.openSetPasswordModal = function openSetPasswordModal() {
    return {
        type: OPEN_SET_PASSWORD_MODAL
    };
};

var openUpdatePasswordModal = exports.openUpdatePasswordModal = function openUpdatePasswordModal() {
    return {
        type: OPEN_CHANGE_PASSWORD_MODAL
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/modal.js
// module id = u90i
// module chunks = 46